import {
  useReducerData,
  useReducerLoading,
  useReducerTotal,
} from 'store/hooks';
import { REDUCER_NAMES, REDUCER_ATTRIBUTES } from 'helper/store';

// RECURRING_RULES_LIST
export const useSelectRecurringRulesLoading = () => {
  return useReducerLoading(
    REDUCER_NAMES.RECURRING_RULES,
    REDUCER_ATTRIBUTES.RECURRING_RULES.RECURRING_RULES_LIST
  );
};
export const useSelectRecurringRules = () => {
  return useReducerData(
    REDUCER_NAMES.RECURRING_RULES,
    REDUCER_ATTRIBUTES.RECURRING_RULES.RECURRING_RULES_LIST,
    []
  );
};

// CREATE_RECURRING_RULE
export const useSelectCreateRecurringRuleLoading = () => {
  return useReducerLoading(
    REDUCER_NAMES.RECURRING_RULES,
    REDUCER_ATTRIBUTES.RECURRING_RULES.CREATE_RECURRING_RULE
  );
};

// UPDATE_RECURRING_RULE
export const useSelectUpdateRecurringRuleLoading = () => {
  return useReducerLoading(
    REDUCER_NAMES.RECURRING_RULES,
    REDUCER_ATTRIBUTES.RECURRING_RULES.UPDATE_RECURRING_RULE
  );
};

// DELETE_RECURRING_RULE
export const useSelectDeleteRecurringRuleLoading = () => {
  return useReducerLoading(
    REDUCER_NAMES.RECURRING_RULES,
    REDUCER_ATTRIBUTES.RECURRING_RULES.DELETE_RECURRING_RULE
  );
};

// AUTOMATED_ORDERS
export const useSelectAutomatedOrders = () => {
  return useReducerData(
    REDUCER_NAMES.RECURRING_RULES,
    REDUCER_ATTRIBUTES.RECURRING_RULES.AUTOMATED_ORDERS_LIST,
    []
  );
};
export const useSelectAutomatedOrdersLoading = () => {
  return useReducerLoading(
    REDUCER_NAMES.RECURRING_RULES,
    REDUCER_ATTRIBUTES.RECURRING_RULES.AUTOMATED_ORDERS_LIST
  );
};
export const useSelectAutomatedOrdersTotal = () => {
  return useReducerTotal(
    REDUCER_NAMES.RECURRING_RULES,
    REDUCER_ATTRIBUTES.RECURRING_RULES.AUTOMATED_ORDERS_LIST
  );
};
